import { render, staticRenderFns } from "./createModal.vue?vue&type=template&id=6857a7e4&scoped=true&"
import script from "./createModal.vue?vue&type=script&lang=js&"
export * from "./createModal.vue?vue&type=script&lang=js&"
import style0 from "./createModal.vue?vue&type=style&index=0&id=6857a7e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6857a7e4",
  null
  
)

export default component.exports